import React from "react";
import { Box } from "@mui/material";
import Colors from "../../../common/Colors";
import Text from "../../../components/Text";

const Floors = ({ data, onClick, selectedFloorId }) => {
  const handleFloorClick = (floor) => {
    onClick(floor);
  };

  // Check if any floor has call_waiter === 1
  const hasCallWaiter = data.some((item) => item.call_waiter === 1);

  const RenderFloor = ({ item, index }) => {
    if (!item) return null;

    const { id, call_waiter = 0, floor_no } = item;

    return (
      <Box
        onClick={() => onClick(item, index)}
        style={{
          padding: "2px 15px",
          margin: "2px 5px",
          borderRadius: 5,
          backgroundColor: selectedFloorId === id ? Colors.btnColor : "#fff",
          position: "relative",
          cursor: "pointer",
        }}
      >
        <Text style={{ color: "#000" }}>{floor_no}</Text>
        {call_waiter === 1 && (
          <Box
            style={{
              position: "absolute",
              top: 2,
              right: 2,
              width: 10,
              height: 10,
              borderRadius: 5,
              backgroundColor: Colors.blueColor,
            }}
          ></Box>
        )}
      </Box>
    );
  };

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
      }}
    >
      {/* "All" option to show all tables */}
      <Box
        onClick={() => onClick({ id: "all", call_waiter: hasCallWaiter ? 1 : 0 }, -1)}
        style={{
          padding: "2px 15px",
          margin: "2px 5px",
          borderRadius: 5,
          backgroundColor: selectedFloorId === "all" ? Colors.btnColor : "#fff",
          position: "relative",
          cursor: "pointer",
        }}
      >
        <Text style={{ color: "#000" }}>All</Text>
        {hasCallWaiter && (
          <Box
            style={{
              position: "absolute",
              top: 2,
              right: 2,
              width: 10,
              height: 10,
              borderRadius: 5,
              backgroundColor: Colors.blueColor,
            }}
          ></Box>
        )}
      </Box>

      {data.map((item, index) => (
        <React.Fragment key={index}>
          <RenderFloor item={item} index={index} />
        </React.Fragment>
      ))}
    </Box>
  );
};

export default Floors;